export const path = {
  HOME: "/",
  HOMEPAGE: "/home",
  LOGIN: "/login",
  LOG_OUT: "/logout",
  SYSTEM: "/system",
  DETAIL_BARBER:"/detail-barber/:id",
  DETAIL_HAIRSTYLE:"/detail-hairstyle/:id",
  DETAIL_BARBERSHOP:"/detail-barbershop/:id",
  VERIFY_EMAIL_BOOKING:"/verify-booking",
};

export const LANGUAGES = {
  VI: "vi",
  EN: "en",
};

export const CRUD_ACTIONS = {
  CREATE: "CREATE",
  EDIT: "EDIT",
  DELETE: "DELETE",
  READ: "READ",
};

export const dateFormat = {
  SEND_TO_SERVER: "DD/MM/YYYY",
};

export const YesNoObj = {
  YES: "Y",
  NO: "N",
};

export const USER_ROLE = {
  ADMIN: 'R1',
  BARBER: 'R2',
  CUSTOMER:'R3',
}
